import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";

const CheckoutForm = () => {
  const initialValues = {
    email: "",
    country: "",
    firstName: "",
    lastName: "",
    address: "",
    city: "",
    postalCode: "",
    phone: "",
    billingAddress: "same",
  };
  const navigate = useNavigate();

  const validationSchema = Yup.object({
    email: Yup.string().email("Invalid email").required("Required"),
    country: Yup.string().required("Required"),
    firstName: Yup.string().required("Required"),
    lastName: Yup.string().required("Required"),
    address: Yup.string().required("Required"),
    city: Yup.string().required("Required"),
    postalCode: Yup.string(),
    phone: Yup.string().required("Required"),
    billingAddress: Yup.string().oneOf(["same", "different"]),
  });

  const handleSubmit = (values) => {
    toast.success("Your Order placed Successfully");
     setTimeout(() => {
      navigate("/");
    }, 1500);
  };

  return (
    <div className="min-h-screen px-4 pt-16 md:pt-24  pb-8 overflow-y-auto">
        <div className=" lg:col-span-2">
          <div className="max-w-4xl mx-auto  shadow-md rounded p-6">
            <h2 className="text-2xl text-center font-bold mb-6">Checkout</h2>

            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={handleSubmit}
            >
              <Form className="space-y-6">
                <div>
                  <h3 className="text-lg font-semibold mb-2">Contact</h3>
                  <div className="flex flex-col">
                    <Field
                      name="email"
                      type="email"
                      placeholder="Email"
                      className="border p-2 rounded text-black"
                    />
                    <ErrorMessage
                      name="email"
                      component="div"
                      className="text-red-500 text-sm mt-1"
                    />
                  </div>
                </div>
                <div>
                  <h3 className="text-lg font-semibold mb-2">Delivery</h3>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div className="md:col-span-2">
                      <Field
                        name="country"
                        placeholder="Country/Region"
                        className="border p-2 rounded w-full text-black"
                      />
                      <ErrorMessage
                        name="country"
                        component="div"
                        className="text-red-500 text-sm mt-1"
                      />
                    </div>
                    <div>
                      <Field
                        name="firstName"
                        placeholder="First name"
                        className="border p-2 rounded w-full text-black"
                      />
                      <ErrorMessage
                        name="firstName"
                        component="div"
                        className="text-red-500 text-sm mt-1"
                      />
                    </div>

                    <div>
                      <Field
                        name="lastName"
                        placeholder="Last name"
                        className="border p-2 rounded w-full text-black"
                      />
                      <ErrorMessage
                        name="lastName"
                        component="div"
                        className="text-red-500 text-sm mt-1"
                      />
                    </div>

                    <div className="md:col-span-2">
                      <Field
                        name="address"
                        placeholder="Address"
                        className="border p-2 rounded w-full text-black"
                      />
                      <ErrorMessage
                        name="address"
                        component="div"
                        className="text-red-500 text-sm mt-1"
                      />
                    </div>

                    <div>
                      <Field
                        name="city"
                        placeholder="City"
                        className="border p-2 rounded w-full text-black"
                      />
                      <ErrorMessage
                        name="city"
                        component="div"
                        className="text-red-500 text-sm mt-1"
                      />
                    </div>

                    <div>
                      <Field
                        name="postalCode"
                        placeholder="Postal code (optional)"
                        className="border p-2 rounded w-full text-black"
                      />
                    </div>

                    <div className="md:col-span-2">
                      <Field
                        name="phone"
                        placeholder="Phone"
                        className="border p-2 rounded w-full text-black"
                      />
                      <ErrorMessage
                        name="phone"
                        component="div"
                        className="text-red-500 text-sm mt-1"
                      />
                    </div>
                  </div>
                </div>

                <div>
                  <h3 className="text-lg font-semibold mb-2">
                    Shipping Method
                  </h3>
                  <div className="border rounded p-3 flex justify-between items-center">
                    <div>
                      <p className="font-medium">Delivery Charges</p>
                    </div>
                    <p className="font-semibold">$4.00</p>
                  </div>
                </div>

                <div>
                  <h3 className="text-lg font-semibold mb-2">Payment</h3>
                  <div className="border rounded p-3">
                    <p className="font-medium">Cash on Delivery (COD)</p>
                    <p className="text-sm text-gray-500">
                      All transactions are secure and encrypted.
                    </p>
                  </div>
                </div>

                <div>
                  <h3 className="text-lg font-semibold mb-2">
                    Billing Address
                  </h3>
                  <div className="space-y-2">
                    <label className="flex items-center gap-2">
                      <Field type="radio" name="billingAddress" value="same" />
                      Same as shipping address
                    </label>
                    <label className="flex items-center gap-2">
                      <Field
                        type="radio"
                        name="billingAddress"
                        value="different"
                      />
                      Use a different billing address
                    </label>
                  </div>
                </div>

                <div>
                  <button
                    type="submit"
                    className="bg-blue-600 text-white py-2 px-6 rounded hover:bg-blue-700"
                  >
                    Confirm Order
                  </button>
                </div>
              </Form>
            </Formik>
          </div>
        </div>
        </div>
  );
};

export default CheckoutForm;
